import React, { useContext, useEffect, useCallback, useState } from 'react';
import { API } from 'api/API';
import { Card, Col, Row, Button, CardGroup, Alert, Spinner } from 'react-bootstrap';
import { ONECLICKPAYMENTS_URL, BUSINESS_DONATION_CAUSES } from 'config/config';
import { extractError } from 'api/ErrorUtil';
import { SecurityContext } from '../../security/SecurityContext';
import { TenantContext } from '../../tenant/TenantContext';
import { formatCurrency } from 'util/Currency';
import { evenRound } from 'util/NumberUtils';

import _ from "lodash";
import { Link } from 'react-router-dom';
import { FormContainer } from 'uiwidgets/FormContainer';

function BusinessBillingHome(props) {
  const { businessConfig } = useContext(TenantContext);
  return (
    <FormContainer title="Home">
      Use the sidebar menus to navigate to different parts of the application. 
    </FormContainer>
  )
}

export default BusinessBillingHome;